<template>
  <v-container class="no-margins">
    <div class="title-icon">
      <h1 class>{{ $t("fields.workplace") }}</h1>
      <v-btn
        icon
        :href="links.ebook.apprenticeInfo"
        target="_blank"
      >
        <v-icon>$sl-question</v-icon>
      </v-btn>
    </div>

    <template>
      <v-expand-transition v-if="workplaces.length > 0">
        <workplaces-list
          :workplaces="workplaces"
          @item-click="check($event)"
          actionType="select"
          withSearch
          flat
          :model="selectedWorkplace"
        ></workplaces-list>
      </v-expand-transition>
    </template>

    <NextButton class="mt-6" @click="next" :isDisabled="isImitatingUser()">{{ $t("labels.instructor") }}</NextButton>
    <BottomNav @clicked="goback" />
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import API from "@/services/api.js";
import NextButton from "@/components/Common/NextButton";
import BottomNav from "@/components/Application/BottomNav";
import WorkplacesList from "@/components/Common/Workplace/WorkplacesList";
import find from "lodash/find";
import { includes } from "lodash";

// @group Common
// Styled EbookWorkplace component
export default {
  name: "EbookWorkplace",

  props: {
    //has current report object
    currentReport: Object,
  },

  components: {
    BottomNav,
    NextButton,
    WorkplacesList,
  },

  data: () => ({
    links: require('../../../lib/external-links.json'),
    workplaces: [],
    report: {},
    selectedWorkplace: -1,
  }),

  created() {
    this.init();
  },

  computed: {
    ...mapGetters("currentuser", ["currentUser", "isApprentice", "isInstructor", "isImitatingUser"]),
  },

  methods: {
    init() {
      if (
        this.currentUser &&
        this.currentUser.books.length > 0 &&
        this.currentReport &&
        this.currentReport.bookId
      ) {
        const book = this.currentUser.books.find(
          (x) => x.id === this.currentReport.bookId
        );
        if (book && book.apprenticeship.companyId) {
          this.getWorkplaces(book);
        }
      }
      this.report = this.currentReport;
    },
    /**
     * @vuese
     * Used to get workplaces
     * @arg The argument is an id number representing workplace id
     */
    getWorkplaces(book) {
      API.getWorkplaces(book.apprenticeship.companyId)
        .then((response) => {
          this.workplaces = response.data || [];
          if (response.data.length > 0) {
            //Just list the workplaces the user has in the apprenticeship
            if (
              book.apprenticeship.workplaces &&
              book.apprenticeship.workplaces.length > 0
            ) {
              let userWorkplaceIds = book.apprenticeship.workplaces.map(
                (wp) => wp.workplaceId
              );

              this.workplaces = response.data.filter((r) =>
                userWorkplaceIds.find((u) => u == r.id)
              );
            }
          }

          //To do -- filter the apprentice workplaces

          if (
            this.currentReport &&
            this.currentReport.workplace &&
            this.currentReport.workplace.id &&
            this.currentReport.workplace.id > 0
          ) {
            this.selectedWorkplace = this.currentReport.workplace.id;
          } 
          else if(this.workplaces && this.workplaces.length>0 && this.workplaces[0].id) {
            this.selectedWorkplace = this.workplaces[0].id;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /**
     * @vuese
     * Used to go to next step
     */
    next() {
      const wp = this.workplaces.find((w) => w.id === this.selectedWorkplace);

      if (!wp) {
        this.$events.fire("showError", "Välj en arbetsplats");
        return;
      }

      if (
        this.report &&
        this.report.id &&
        this.report.id > 0 &&
        this.report.bookId &&
        this.report.bookId > 0
      ) {
        API.updateReport(this.report.bookId, this.report.id, {
          data: { workplaceId: wp.id },
        })
          .then((response) => {
            this.report.workplaceId = wp.id;
            this.report.workplace = wp;
            const params = { report: this.report, goto: "instructor" };

            this.$emit("goto", params);
          })
          .catch((error) => {
            console.log("Error: " + error);
          });
      }
    },
    goback() {
      // Fire go to
      // @arg The argument is a object representing current report
      this.$emit("goto", { report: this.currentReport, goto: "period" });
    },
    check(item) {
      this.selectedWorkplace = item.id;
    },
  },
};
</script>
